import { Component, OnChanges, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { environment } from '../../environments/environment';
import { IRoughcheck, IAssessment, ISection, IQuestion } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
})
export class SectionComponent implements OnInit, OnChanges {

  @Input() section: ISection = {
    id: '',
    title: '',
    description: ''
  };

  roughcheck: IRoughcheck = {
    rref: '',
    title: '',
    image: '',
    image_alt: '',
    category: '',
    riskprofile: '',
    rewardprofile: '',
    show_risk_reward: 1,
    description: '',
    slug: '',
    status: 0,
    status_email: 0,
    feedback: 0,
    sponsor: '',
    website: ''
  };
  questions: IQuestion[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private location: Location,
    private message: MessageService,
    private logger: LoggerService,
    private title: Title
  ) { }

  ngOnInit(): void {
    this.section = {
      id: '',
      title: '',
      description: ''
    };
  }

  /**
   * When the section changes, clear existing questions if any
   * then fetch and display new ones
   */
  ngOnChanges(): void {
    if (this.section) {
      if (this.section.id) {
        this.service.getHttpQuestions(this.section.id)
          .subscribe(
            (resp) => this.handleSuccess(resp),
            (error) => this.service.handleError(error)
          );
      }
    }
  }
  /**
   * Populate Sections then go to the first one
   */
  private handleSuccess(resp: HttpResponse<any>) {
    const questions: IQuestion[] = resp.body;
    this.questions = questions;
    this.roughcheck = this.service.getRoughcheck();
  }

  /**
   * Risk/Reward display order
   * ROUGHCHECK_RR_NONE = 0
   * ROUGHCHECK_RR_RISK_REWARD = 1
   * ROUGHCHECK_RR_REWARD_RISK = 2
   * ROUGHCHECK_RR_RISK = 3
   * ROUGHCHECK_RR_REWARD = 4
   */
  isRiskFirst(): boolean {
    if (this.roughcheck.show_risk_reward === 1) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Size for Risk/Reward columns
   * If one then 2 else 4
   * If none then not displayed
   */
  sizeRiskRewardCols(): string {
    if (this.roughcheck.show_risk_reward === 0) {
      return '2';
    } else if (this.roughcheck.show_risk_reward === 1) {
      return '4';
    } else if (this.roughcheck.show_risk_reward === 2) {
      return '4';
    } else if (this.roughcheck.show_risk_reward === 3) {
      return '2';
    } else if (this.roughcheck.show_risk_reward === 4) {
      return '2';
    } else {
      return '4';
    }
  }
  /**
   * Size for Risk/Reward select
   * If one then 2 else 4
   * If none then not displayed
   */
  sizeRiskRewardSelect(): string {
    if (this.roughcheck.show_risk_reward === 0) {
      return '6';
    } else if (this.roughcheck.show_risk_reward === 1) {
      return '6';
    } else if (this.roughcheck.show_risk_reward === 2) {
      return '6';
    } else if (this.roughcheck.show_risk_reward === 3) {
      return '12';
    } else if (this.roughcheck.show_risk_reward === 4) {
      return '12';
    } else {
      return '12';
    }
  }
  /**
   * Hide Risk
   */
  hideRisk(): boolean {
    if (this.roughcheck.show_risk_reward === 0) {
      return true;
    } else if (this.roughcheck.show_risk_reward === 4) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Hide Reward
   */
  hideReward(): boolean {
    if (this.roughcheck.show_risk_reward === 0) {
      return true;
    } else if (this.roughcheck.show_risk_reward === 3) {
      return true;
    } else {
      return false;
    }
  }
}
